// Resolves media URLs to the backend (API) origin.
//
// Uploaded media lives on the backend and is served at <api-origin>/uploads/media/...
// (see backend/services/mediaStorage.js + app.js). Stored URLs are root-relative
// ("/uploads/media/...."), so when rendered on the separately-hosted frontend
// (tanaka.co.za) the browser would resolve them against the frontend origin and 404.
// These helpers rewrite root-relative /uploads URLs to the API origin. They are
// idempotent: already-absolute (http/https) URLs pass through unchanged, so they work
// for both existing content and future absolute URLs.

// Mirrors BASE_URLS in utils/apiRequest.js, minus the /api/ path (uploads are at the
// host root, not under /api).
const API_ORIGINS = {
  production: "https://api.tanaka.co.za",
  staging: "https://sapi.tanaka.co.za",
  development: "http://localhost:4000",
}

export function getApiOrigin() {
  if (typeof window !== "undefined") {
    const url = window.location.href
    if (url.includes("localhost")) return API_ORIGINS.development
    if (url.includes("staging")) return API_ORIGINS.staging
  }
  return API_ORIGINS.production
}

// Resolve a single media URL (e.g. a cover image) to an absolute backend URL.
export function resolveMediaUrl(u) {
  if (!u) return u
  if (/^https?:\/\//i.test(u)) return u // already absolute
  if (u.startsWith("/uploads/")) return getApiOrigin() + u
  return u
}

// Rewrite every root-relative /uploads/ reference inside an HTML string (blog body,
// which is rendered via dangerouslySetInnerHTML) to the absolute backend URL.
export function resolveMediaInHtml(html) {
  if (!html) return html
  const origin = getApiOrigin()
  return html.replace(/(src|href)=(["'])\/uploads\//gi, `$1=$2${origin}/uploads/`)
}
